import { Collection, WhereField } from "../../shared/constants";
import { addDoc, deleteDoc, getAllDocsByParkId, updateDoc, getDocByQueries } from "./collectionBaseWorker";
import { where } from "firebase/firestore";

export const getAllAccreditedsByParkId = async ({ estacionamentoId }) => {
    const docs = await getAllDocsByParkId({ collection: Collection.ACCREDITEDS, estacionamentoId: estacionamentoId })
    return docs
}

export const getAccreditedVehicleByParkIdAndPlate = async ({ estacionamentoId, plate }) => {
    const accrediteds = await getAllAccreditedsByParkId({ estacionamentoId: estacionamentoId })
    return accrediteds.filter(accredited => accredited.veiculos?.some(veiculo => veiculo.placa === plate))
}

export const addAccredited = async ({ data }) => {
    await addDoc({ collection: Collection.ACCREDITEDS, data: data })
}

export const updateAccredited = async ({ id, data }) => {
    await updateDoc({ collection: Collection.ACCREDITEDS, id: id, data: data })
}

export const deleteAccreditedById = async ({ id }) => {
    await deleteDoc({ collection: Collection.ACCREDITEDS, id: id })
}